/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

export default function FilterHeaderMobile({
  isOverlayOpened,
  isMobile,
  text,
  handleClose,
}) {
  const renderedHeader =
    isOverlayOpened && isMobile ? (
      <div className="search-menu__mobile">
        <h2 className="search-mobile__title">{text}</h2>
        <button
          type="button"
          className="search-menu__mobile-close"
          onClick={handleClose}
        />
      </div>
    ) : null;

  return <div>{renderedHeader}</div>;
}

FilterHeaderMobile.propTypes = {
  isOverlayOpened: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};
